﻿import React, { Fragment, useRef } from 'react';
import { Icon, Position } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import './Wizard.css';
import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import { Tooltip } from 'components/tooltip';

export function WizardSteps(
    {
        additionalStepInformation = [],
        showStepTitles = false,
        allowDirectStepNavigation = false,
        loading = false,
        minimal = false,
        wizardComplete = false,
        currentStep,
        onStepClick,
        totalSteps
    }
) {
	const dummyNumberOfSteps = 10;

	const wizardStepsRef = useRef(null);

	function createSteps(totalStepsValue) {
		let steps = [];
		let stepsBeforeAreComplete = true;
		
		for (let i = 0; i < totalStepsValue; i++) {
			const stepId = 'step-' + i.toString();
			let iconClass = null;
			let stepClass = 'wizard-step ';

			if (i === currentStep) {
				iconClass = 'dot';
				stepClass += 'wizard-step-current';
			} else if (!allowDirectStepNavigation && i < currentStep) {
				iconClass = 'small-tick';
				stepClass += 'wizard-step-complete wizard-step-highlight-line';
			} else if (allowDirectStepNavigation) {
				const stepStatus = getStepStatus(i);
				switch (stepStatus.toUpperCase()) {
					case 'COMPLETE':
						stepClass += 'wizard-step-complete';
						iconClass = 'small-tick';
						break;
					case 'COMPLETE-WITH-ERRORS':
						stepClass += 'wizard-step-errors';
						iconClass = 'small-cross';
						break;
					default:
						stepsBeforeAreComplete = false;
						break;
				}
			}

			if (stepsBeforeAreComplete && i > 0 && i <= currentStep) {
				steps[i - 1].stepClass += ' wizard-step-highlight-line';
			}

			steps.push({
				stepId: stepId,
				iconClass: iconClass,
				stepClass: stepClass,
			});
		}

		return steps.map((step, i) => (
			<div key={step.stepId} className={step.stepClass} onClick={() => onStepClick(i)} onKeyDown={(e) => { }}>

			<ShowHide
				evaluator={minimal && showStepTitles}
				show={(
					<Tooltip content={getStepTitle(i)} position={Position.BOTTOM}>
							<div>
								<Icon icon={step.iconClass} size={16} />
							</div>
					</Tooltip>
				)}
					hide={(
					<Fragment>
						<div>
							<Icon icon={step.iconClass} size={16} />
						</div>
						<ShowHide
							evaluator={showStepTitles && !minimal}
							show={<span className='wizard-step-title'></span>}
							/>
						</Fragment>
				)}
			/>
					</div>

		));	
	}

	function getStepTitle(stepIndex) {
		let stepTitle = '';

		if (additionalStepInformation && stepIndex < additionalStepInformation.length) {
			stepTitle = additionalStepInformation[stepIndex].stepTitle;
		}

		return stepTitle;
	}

	function getStepStatus(stepIndex) {
		let stepStatus = '';

		if (additionalStepInformation && stepIndex < additionalStepInformation.length) {
			stepStatus = additionalStepInformation[stepIndex].stepStatus;
		}

		return stepStatus
	}

	return (
        <div className='wizard-steps-container'>
            <div ref={wizardStepsRef} className={classNames('wizard-steps', { 'wizard-steps-minimal': minimal, 'wizard-steps-with-titles': showStepTitles, 'wizard-steps-with-navigation': allowDirectStepNavigation, 'bp6-skeleton': loading, 'wizard-complete': wizardComplete })}>
				<ShowHide
					evaluator={!loading || totalSteps > 0}
					show={createSteps(totalSteps)}
					hide={createSteps(dummyNumberOfSteps)}
				/>
			</div>
        </div>
    );
}

WizardSteps.propTypes = {
	currentStep: PropTypes.number.isRequired,
	totalSteps: PropTypes.number.isRequired,
	additionalStepInformation: PropTypes.array,
	showStepTitles: PropTypes.bool,
	onStepClick: PropTypes.func.isRequired,
	allowDirectStepNavigation: PropTypes.bool,
	loading: PropTypes.bool,
	minimal: PropTypes.bool,
	wizardComplete: PropTypes.bool
};